import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../../_redux/homeworks/HomeworksAction";
import * as uiHelpers from "../StudentsUIHelpers";
import {
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../../_metronic/_partials/controls";
import { useStudentsUIContext } from "../StudentsUIContext";

export function StudentsTable() {
  // Students UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      queryParams: studentsUIContext.queryParams,
      setQueryParams: studentsUIContext.setQueryParams
    };
  }, [studentsUIContext]);

  // Getting curret state of Students list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.homeworks }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;
  
  // Students Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getHomeworkReceipents(studentsUIProps.queryParams));
    return () => dispatch(actions.cleanHomeworksState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentsUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "studentNumber",
      text: "Öğrenci Numarası",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "studentName",
      text: "Adı Soyadı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "homeworkStatusName",
      text: "Durum",      
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "evaluationExplanation",
      text: "Değerlendirme Açıklaması",
      sort: true,
      sortCaret: sortCaret
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: studentsUIProps.queryParams.pageSize,
    page: studentsUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                studentsUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}